
import { Empty } from 'element-ui';
<template>
    <div>
        <div class="content">
                <div class="form-item" prop="url">
                    <img src="@/assets/url.svg" />
                    <input class="form-input" ref="url" v-model="form.url" type="text" name="url" placeholder="请输入你需要缩短的网址" />
                </div>
                <div class="form-bottom">
                    <button class="btn" @click="urlHttp">立即缩短</button>
                </div>
                <div class="box1" v-if="shorData.shorturl">
                    <div>{{shorData.shorturl}}</div>
                    <div><button class="btn" @click="copyText">复制</button></div>
                </div>
                <div class="box_con">
                    <p>历史记录</p>
                    <div class="box" v-for="(item,index) in shorList" :key="index">
                        <div><span class="chaochu1">缩短后：{{item.shorturl}}</span></div>
                        <div><span class="chaochu1">缩短前：{{item.shorturl2}}</span></div>
                    </div>
                </div>
        </div>
    </div>
</template>
<script>
import Cookies from 'js-cookie'
// import { getToken, setToken, removeToken } from '@/utils/auth'
export default {
    name: 'IndexComponent',
    data() {
        return{
            form:{
                url:''
            },
            shorData:[],
            shorList:[]
        }
    },

    methods: {
        urlHttp(){
            let {url} = this.form
            if(!url){
                alert('请输入需要缩短的网址')
                return
            }
            this.$post('apiv1/shorturl/add?url='+url).then(e => {
                if(e){
                    let shorList = Cookies.get('shorList') ? JSON.parse(Cookies.get('shorList')) : []
                    let data = e.data
                    let dataFind = {"shorturl":data.shorturl,"shorturl2":url}
                    this.shorData = dataFind
                    shorList.push(dataFind)
                    Cookies.set('shorList', JSON.stringify(shorList));
                    this.setHttp()
                }
            })
        },
        setHttp(){
            let shorList = Cookies.get('shorList')
            if(shorList){
                shorList = JSON.parse(Cookies.get('shorList')) || []
                this.shorList = shorList
            }
        },
        copyText() {
            const textToCopy = this.shorData.shorturl;
            this.$copyText(textToCopy).then(() => {
                alert('复制成功')
            }, () => {
                alert('复制失败')
            })
        }
    },
    created() {
        this.setHttp()
    },
}
</script>
<style scoped>
    .content{ background: #e8e8e8; width: 50%; margin:0 auto; padding: 30px 0 40px 0;}
    .form-item{display: flex; width:70%; background: #fff; border:unset; padding:7px 10px; margin: auto;}
    .form-item img{flex:0 0 30px; width: 30px; vertical-align: -9px; margin-right: 10px;}
    .form-item input{ flex: 1; background-color:#fff; border: unset; outline: unset;}
    .form-bottom{margin-top: 20px;}
    .btn{width:300px; background-color: #50d711; border:unset; color: #fff; padding:10px; cursor: pointer;}
    .box_con{width:70%; margin: auto;max-height: 800px; overflow: auto; margin-top: 20px;}
    .box span{display:block;width: 100%;}
    .box1{width:70%; margin: auto;}
    .box1,.box{text-align: left; margin-top: 10px;}
    .box_con p{text-align: left;}
    .box1>div,.box>div{display: inline-block; width: 49%;}
    .box1>div+div,.box>div+div{margin-left: 10px;}
    .box1>div{width:auto;}
    .box1 .btn{width: auto;}
    .chaochu1{
        white-space: nowrap;
        
    overflow: hidden;
    text-overflow: ellipsis;
    }
</style>